// Global loading infrastructure (foundation). A styled spinner/skeleton system is a
// design-system concern for Phase 6.2; this is the minimal full-screen fallback.
export function LoadingScreen({ label = 'იტვირთება…' }: { label?: string }): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full w-full items-center justify-center text-fg-muted"
    >
      {label}
    </div>
  );
}
